import { render, staticRenderFns } from "./new-rate-button.vue?vue&type=template&id=3158c646&"
import script from "./new-rate-button.vue?vue&type=script&lang=js&"
export * from "./new-rate-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports